import { fetchJsonResponse } from '@/ai/api'
import { buildReadModelFromEntityPrompt } from '@/ai/prompts'

export const generateReadModelFromEntity = async ({
  eventId,
  workflow,
  entity,
  cardTypes,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildReadModelFromEntityPrompt({
    eventId,
    workflow,
    entity,
    cardTypes
  })

  const response = await fetchJsonResponse({
    messages,
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
